/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../../components/CircularLoading";
import { features, dateStyle, language } from "config";
import { FirebaseContext } from "common";
import AlertDialog from "../../components/AlertDialog";
import { useNavigate, useLocation } from "react-router-dom";
import Material_React_Table from "../../components/React_Material_Table/Material_React_Table";
import { Box } from "@mui/material";

export default function Notes({ Booking }) {
  // Actions Declare
  const { api } = useContext(FirebaseContext);
  const { editUser, deleteUser, clearLoginError, updateBooking } = api;

  // Hooks
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Reducers
  const auth = useSelector((state) => state.auth);
  const usersdata = useSelector((state) => state.usersdata);

  // States
  const booking = location.state?.Booking 
  const [notes, setNotes] = useState([]);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [details, setdetails] = useState(location.state.Booking);
  // Table Fields
  const columns = [
    { header: language.personid, accessorKey: "person_id" },
    { header: language.note_text, accessorKey: "note_text" },
    { header: language.note_date, accessorKey: "note_date"  ,type :"date" },
    { header: language.note_datetime, accessorKey: "note_datetime" ,type : "time"},
  ];

  const onRowAdd = (newData) =>
    new Promise((resolve) => {
      setTimeout(() => {
        newData.person_id = details.patient;
        let tempArr = [...notes, newData];
        setNotes(tempArr);
        dispatch(updateBooking({ ...booking, medicalNote: tempArr }));
        resolve();
      }, 800);
    });

  const onRowUpdate = (newData, oldData) =>
    new Promise((resolve) => {
      setTimeout(() => {
        let tempArr = [...notes];
        const indexOf = notes.indexOf(oldData);

        if (indexOf > -1) {
          tempArr[indexOf] = newData;
          setNotes(tempArr);
          dispatch(updateBooking({ ...booking, medicalNote: tempArr }));
        } else {
          setCommonAlert({ open: true, msg: "No note found, can't update" });
        }

        dispatch(editUser(oldData.id, newData));
        resolve();
      }, 600);
    });

  const onRowDelete = (oldData) =>
    new Promise((resolve) => {
      setTimeout(() => {
        let tempArr = [...notes];
        const indexOf = notes.indexOf(oldData);

        if (indexOf > -1) {
          tempArr.splice(indexOf, 1);
          setNotes(tempArr);
          dispatch(updateBooking({ ...booking, medicalNote: tempArr }));
        } else {
          setCommonAlert({ open: true, msg: "No note found, can't delete" });
        }

        resolve();
      }, 600);
    });

  // UseEffects
  useEffect(() => {
    if (booking?.medicalNote) {
      setNotes(Object.values(booking.medicalNote));
    } else {
      setNotes([]);
    }
  }, [booking]);

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };

  // Render View
  return usersdata.loading ? (
    <CircularLoading />
  ) : (
    <Box>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
      <Material_React_Table
        data={notes} 
        columns={columns}
        userInitialState={{
          columnVisibility: { person_id: false },
        }}
        onRowAdd={onRowAdd}
        onRowUpdate={onRowUpdate}
        onRowDelete={onRowDelete}
      />
    </Box>
  );
}
